import { useState, useEffect } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import { inventoryItems, itemStates } from "./create-property-data"
import { getProperty, updateProperty } from "../../actions/property-actions"
import { alert } from "../../components/Alert"
import { useApp } from "../../context/useApp"
import "./inventory.css"

function Inventory() {
  const currentLink = "/inmuebles"
  const navigate = useNavigate()
  const { user, setLoading } = useApp()
  const [loadData, setLoadData] = useState(true)
  const params = useParams()

  const [form, setForm] = useState({
    _id: "",
    implements: "",
    observations: "",
    services: "",
    inventory: [],
  })

  const [currentData, setCurrentData] = useState({})

  useEffect(() => {
    if (loadData) {
      ;(async () => {
        try {
          const data = await getProperty(params.id, setLoading, user.token)
          if (data.code === "01") {
            alert("Error", data.message)
            return
          }

          setCurrentData(data.data[0])

          let newInventory = []

          if (data.data[0].inventory.length > 0) {
            newInventory = data.data[0].inventory
          } else {
            inventoryItems.map((item) => {
              let obj = {
                name: item,
                state: "Bueno",
                quantity: 1,
                brand: "",
                material: "",
                observations: "",
              }
              newInventory.push(obj)

              return item
            })
          }

          setForm({
            ...form,
            _id: data.data[0]._id,
            services: data.data[0].services,
            implements: data.data[0].implements,
            observations: data.data[0].observations,
            inventory: newInventory,
          })
        } catch (error) {
          console.error("Error loading property:", error)
        }
      })()

      setLoadData(false)

      setForm({
        _id: "",
        implements: "",
        observations: "",
        services: "",
        inventory: [],
      })
    }
  }, [loadData, params.id, user?.token])

  const handleInputChange = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    })
  }

  const handleInventoryChange = (event, index) => {
    form.inventory[index][event.target.name] = event.target.value
    setForm({
      ...form,
    })
  }

  const handleOnSubmit = async (event) => {
    event.preventDefault()
    try {
      const result = await updateProperty(form, setLoading, user.token)
      if (result.code === "01") {
        alert("Error", result.message)
        return
      }
      alert("¡Éxito!", "Inmueble actualizado con éxito")
      navigate(-1)
    } catch (error) {
      console.error("Error updating property:", error)
    }
  }

  useEffect(() => {
    //console.log(form)
  }, [form])

  return (
    <div className="w-100 d-flex">
      <div className="container d-flex flex-column">
        <div className="inventory-header">
          <Link
            to={`${currentLink}/${params.id}/editar`}
            className="back-button"
          >
            &#60; Volver
          </Link>
          {Object.keys(currentData).length > 0 && (
            <h1>Inventario - {currentData.code}</h1>
          )}
        </div>

        <form onSubmit={handleOnSubmit} className="inventory-form">
          {/* Sección de Inventario - Items */}
          <section className="inventory-section">
            <h2>Items del inmueble</h2>
            <table className="inventory-table">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Estado</th>
                  <th>Cantidad</th>
                  <th>Material</th>
                  <th>Marca</th>
                  <th>Observaciones</th>
                </tr>
              </thead>
              <tbody>
                {form.inventory.map((item, index) => (
                  <tr key={`${item.name}${index}`}>
                    <td className="item-name-col" data-label="Item">
                      {item.name}
                    </td>
                    <td data-label="Estado">
                      <select
                        className="input-field"
                        id={`state${index}`}
                        name="state"
                        value={form.inventory[index].state}
                        onChange={(e) => handleInventoryChange(e, index)}
                      >
                        <option value="">Seleccionar</option>
                        {itemStates.map((state, stateIndex) => (
                          <option key={`${state}${stateIndex}`} value={state}>
                            {state}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td data-label="Cantidad">
                      <input
                        id={`quantity${index}`}
                        name="quantity"
                        value={form.inventory[index].quantity}
                        autoComplete="off"
                        className="input-field"
                        type="number"
                        min="0"
                        onChange={(e) => handleInventoryChange(e, index)}
                        placeholder="1"
                      />
                    </td>
                    <td data-label="Material">
                      <input
                        id={`material${index}`}
                        name="material"
                        value={form.inventory[index].material}
                        placeholder="Ej: Metal, madera"
                        autoComplete="off"
                        className="input-field"
                        type="text"
                        onChange={(e) => handleInventoryChange(e, index)}
                      />
                    </td>
                    <td data-label="Marca">
                      <input
                        id={`brand${index}`}
                        name="brand"
                        value={form.inventory[index].brand}
                        placeholder="Ej: Corona"
                        autoComplete="off"
                        className="input-field"
                        type="text"
                        onChange={(e) => handleInventoryChange(e, index)}
                      />
                    </td>
                    <td data-label="Observaciones">
                      <input
                        id={`observations${index}`}
                        name="observations"
                        value={form.inventory[index].observations}
                        className="input-field"
                        type="text"
                        placeholder="Ej: Presenta pequeño daño"
                        onChange={(e) => handleInventoryChange(e, index)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>

          {/* Sección de Descripciones */}
          <section className="inventory-section">
            <h2>Descripción del inmueble</h2>

            <div className="description-fields">
              <div className="d-flex flex-column w-100 field">
                <label className="label-field" htmlFor="implements">
                  Pisos, paredes, implementos
                </label>
                <textarea
                  id="implements"
                  name="implements"
                  placeholder="Describe el estado de pisos, paredes y otros implementos fijos..."
                  autoComplete="off"
                  rows={4}
                  className="input-field textarea-field"
                  onChange={handleInputChange}
                  value={form.implements}
                ></textarea>
              </div>

              <div className="d-flex flex-column w-100 field">
                <label className="label-field" htmlFor="services">
                  Servicios, cosas y usos adicionales
                </label>
                <textarea
                  id="services"
                  name="services"
                  placeholder="Detalla servicios disponibles (agua, gas, electricidad), áreas comunes, etc..."
                  autoComplete="off"
                  rows={4}
                  className="input-field textarea-field"
                  onChange={handleInputChange}
                  value={form.services}
                ></textarea>
              </div>

              <div className="d-flex flex-column w-100 field">
                <label className="label-field" htmlFor="observations">
                  Observaciones generales
                </label>
                <textarea
                  id="observations"
                  name="observations"
                  placeholder="Ej: Todo se encuentra en buen estado. Requiere mantenimiento en..."
                  autoComplete="off"
                  rows={4}
                  className="input-field textarea-field"
                  onChange={handleInputChange}
                  value={form.observations}
                ></textarea>
              </div>
            </div>
          </section>

          {/* Botón de Envío */}
          <div className="form-actions">
            <button className="primary-button save-button" type="submit">
              <span>✓</span> Actualizar inventario
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Inventory
